// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "wp-content/themes/betano-blog/css/" + chunkId + "." + {"22":"5a1047e0","48":"fe674992","98":"411a27f7","181":"411a27f7"}[chunkId] + ".css";
};